// lib
import React from 'react'
import {
  AvatarFragmentFragment,
  ShapeSponsorshipLevel
} from '@lopo-tech/lopo-api'

// components
import ItemSegmentBase, {
  itemSegmentCls,
  XBIG_ITEM_SEGMENT
} from 'src/components/item_segment/base/item_segment_base'
import ItemSegmentLink, {
  IProps as ILinkProps
} from 'src/components/item_segment/base/item_segment_link'
import {
  IUserListAction,
  IUserListAdminAction
} from 'src/components/item_segment/layouts/profiles_list/model'
import SegmentIcon from 'src/components/item_segment/parts/segment_icon/segment_icon'
import SegmentRoundIcon from 'src/components/item_segment/parts/segment_round_icon/segment_round_icon'
import SegmentText from 'src/components/item_segment/parts/segment_text/segment_text'
import { SegmentUserActionType } from 'src/components/item_segment/parts/segment_user_action_button/model'
import SegmentUserActionButton from 'src/components/item_segment/parts/segment_user_action_button/segment_user_action_button'
import SegmentAvatar from '../../parts/segment_avatar/segment_avatar'

// helpers
import { textResources } from 'src/lang/de'

// constants/interfaces
import { COLOR_TYPE_GRAY_TINT_1 } from 'src/utils/color'
import SegmentUserActions from '../../parts/segment_user_actions/segment_user_actions'
import './profiles_list.scss'
import FollowButton from 'src/containers/smart_components/follow_button/follow_button'
import { getSponsorBadge } from 'src/utils/badges'

interface IProps {
  label: string;
  description?: string | null;
  shapeSponsorshipLevel?: ShapeSponsorshipLevel | null;
  avatar: AvatarFragmentFragment;
  action?: IUserListAction & IUserListAdminAction;
  navigation?: ILinkProps;
}

const cls = itemSegmentCls + 'profiles-list'

const ProfilesListItemSegment: React.FC<IProps> = ({
  label,
  description,
  navigation,
  avatar,
  action,
  shapeSponsorshipLevel
}) => {
  return (
    <ItemSegmentBase
      className={cls}
      height={XBIG_ITEM_SEGMENT}
      rounded
      noSpacing
    >
      <ItemSegmentLink {...navigation}>
        <SegmentAvatar
          imageUrl={avatar.previewUrl}
          badge={
            shapeSponsorshipLevel ? getSponsorBadge(shapeSponsorshipLevel) : undefined
          }
          rounded={false}
          withBorder
        />
        <SegmentText label={label} description={description} labelSize="big" />
        {action?.unblock && (
          <SegmentIcon name="ban" color={COLOR_TYPE_GRAY_TINT_1} size={16} />
        )}
        {action?.unhide && (
          <SegmentIcon name="mute" color={COLOR_TYPE_GRAY_TINT_1} size={16} />
        )}
      </ItemSegmentLink>
      {action?.message?.onClick && (
        <ItemSegmentLink onClick={action.message.onClick} noGrow>
          <SegmentRoundIcon
            isLightRadius={true}
            name="paper-plane"
            color={COLOR_TYPE_GRAY_TINT_1}
            isSmall
            description={textResources.shared.writeMessage}
          />
        </ItemSegmentLink>
      )}
      {action?.follow && <FollowButton {...action.follow} />}
      {action?.accept && (
        <SegmentUserActions>
          <SegmentUserActionButton
            type={SegmentUserActionType.ACCEPT}
            action={action.accept.action}
            confirmation={action.accept.confirmation}
          />
        </SegmentUserActions>
      )}
      {action?.remove && (
        <SegmentUserActions>
          <SegmentUserActionButton
            type={SegmentUserActionType.REMOVE}
            action={action.remove.action}
            confirmation={action.remove.confirmation}
          />
        </SegmentUserActions>
      )}
    </ItemSegmentBase>
  )
}

export default ProfilesListItemSegment
